<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="font-bold text-center mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ filter(items, 'type', 'text')[0]?.value.text }}
    </div>
    <p-timeline [align]="'left'" [value]="filter(items, 'type', 'cte')">
      <ng-template pTemplate="marker" let-cte>
        @if (cte.value.url) {
          <img
            [src]="cte.value.url"
            class="w-[40px] h-[40px] object-cover rounded-full" />
        }
      </ng-template>
      <ng-template pTemplate="content" let-cte>
        <div class="mb-4">
          <small
          [attr.style]="buildStyle('text', cte.styles?.date)"
            >{{ cte.value.date | formatDate }}</small
          >
          <div
            [attr.style]="buildStyle('text', cte.styles?.text)"
            class="font-bold">
            {{ cte.value.text }}
          </div>
          @if (getGoogleMapsLink(cte.value.location); as locationLink) {
            <a
              [href]="locationLink"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center gap-1 mb-1 px-2 py-1 rounded-full bg-blue-50 border border-blue-200 no-underline">
              <span class="pi pi-map-marker text-[10px]"></span>
              <span [attr.style]="buildStyle('locationLink', getLocationLinkStyle(cte))">
                Open in Google Maps
              </span>
            </a>
          }
          <div
            [attr.style]="buildStyle('description', cte.styles?.description)" [innerHTML]="cte?.value?.description | lineBreak">
          </div>
        </div>
      </ng-template>
    </p-timeline>
  </div>
</div>
